export default function (_this) {
  return {
    async create (data, cb) {
      const kanbanOptions = {
        lanesStorage: data.lanesStorage,
        itemsStorage: data.itemsStorage,
        laneCol: data.laneCol,
        titleCol: data.titleCol,
        statusCol: data.statusCol,
        descriptionCol: data.descriptionCol,
        sortIndexCol: data.sortIndexCol,
        template: data.template,
        workflow:data.workflow
      }
      if (data.onChangeScript) kanbanOptions.onChangeScript = data.onChangeScript

      const kanbanId = await new Promise((resolve) => {
        const key = _this.getRef('widgetsData/kanbanData').push(kanbanOptions, () => {
          resolve(key)
        }).key
      })

      const widget = {
        template: `<Kanban kanbanId="${kanbanId}" />`,
        gsOptions: data.gsOptions,
        tab: data.tab,
        subtab: data.subtab || null,
        layout: 'b-card'
      }

      const widgetKey = await new Promise((resolve) => {
        _this.widgets.create(widget, (key) => {
          resolve(key)
        })
      })

      _this.getRef(`widgets/${widgetKey}/dependency`)
        .set(`kanbanData/${kanbanId}`, () => (cb()))
    },
    readOptions (kanbanId, cb) {
      _this.getRef('widgetsData/kanbanData')
        .child(kanbanId)
        .on('value', (snapshot) => {
          var op = snapshot.val()


          cb(op)
        })
    },
    saveOptions (kanbanId, options, cb) {
      _this.getRef('widgetsData/kanbanData')
        .child(kanbanId)
        .set(options, () => (cb()))
    }
  }
}
